import { Page, SkeletonView, Stack } from "@towersystems/roam-common-native";
import { Spacings, View } from "react-native-ui-lib";

export interface ResourcePageSkeletonProps {
  showActions?: boolean;
}

export const ResourcePageSkeleton = ({
  showActions = true,
}: ResourcePageSkeletonProps) => {
  const actionsMarkup = showActions ? (
    <View style={{ marginVertical: Spacings.s5 }}>
      <Stack spacing={Spacings.s5}>
        <SkeletonView style={{ width: 230 }} height={120} />
        <SkeletonView style={{ width: 230 }} height={120} />
      </Stack>
    </View>
  ) : undefined;

  const cardMarkup = (
    <View>
      <SkeletonView
        textVariant="heading"
        style={{ width: 100, marginBottom: Spacings.s4 }}
      />
      <SkeletonView style={{ width: "100%" }} height={300} />
    </View>
  );

  return (
    <Page>
      <Stack vertical spacing={Spacings.s5}>
        <View>
          <SkeletonView
            textVariant="heading"
            style={{ width: 260, marginBottom: Spacings.s2 }}
          />
          <SkeletonView textVariant="heading" style={{ width: 100 }} />
        </View>
        {actionsMarkup}
        {cardMarkup}
      </Stack>
    </Page>
  );
};
